import { z } from 'zod';

/**
 * Email update form validation schema (治療院基本情報 - メールアドレス)
 */
export const emailUpdateFormSchema = z.object({
  email: z.preprocess(
    s => (typeof s === 'string' ? s.trim() : s),
    z
      .string()
      .min(1, 'メールアドレスは必須です')
      .max(255, 'メールアドレスは255文字以下にしてください。')
      .email('メールアドレスを正しいメールアドレスにしてください。')
  ),
});

export type EmailUpdateFormData = z.infer<typeof emailUpdateFormSchema>;

/**
 * Change password form validation schema (ログインパスワード変更)
 * Matches RA2 ClinicInformationController: required|alpha_num|min:6|regex letters+numbers|confirmed
 */
export const changePasswordFormSchema = z
  .object({
    // Trim inputs first so all-space input is treated as empty using preprocess
    password: z.preprocess(
      s => (typeof s === 'string' ? s.trim() : s),
      z
        .string()
        .min(1, 'パスワードは必須です。')
        .min(6, 'パスワードは6文字以上にしてください。')
        .max(255, 'パスワードは255文字以下にしてください。')
        .refine(
          (val: string) => /^[a-zA-Z0-9]+$/.test(val),
          'パスワードは英数字のみにしてください。'
        )
        .refine(
          (val: string) => /[a-zA-Z]/.test(val) && /\d/.test(val),
          'パスワードの書式が正しくありません。'
        )
    ),
    password_confirmation: z.preprocess(
      s => (typeof s === 'string' ? s.trim() : s),
      z.string().min(1, 'パスワード確認は必須です。')
    ),
  })
  .refine(data => data.password === data.password_confirmation, {
    message: 'パスワード確認はパスワードと一致していません。',
    path: ['password_confirmation'],
  });

export type ChangePasswordFormData = z.infer<typeof changePasswordFormSchema>;
